import axios from "../../../config/axios";

export default {
  obtenerDesdeNotas,
};

function obtenerDesdeNotas(ids) {
  const params = {
    ids,
    ignoreLoadingBar: true,
  };
  return axios
    .post(`${axios.defaults.baseUrl}/api/transPublica/notas`, params)
    .then(resp => resp.data)
    .catch(err => err);
}



// WEBPACK FOOTER //
// ./src/components/notas/rest/transcripcionApi.js